import React from 'react'
import Login from '../components/login'
import {Switch, Route} from 'react-router-dom'

export default class Account extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />
      </Switch>
    )
  }
}

class Logout extends React.Component {
  render() {
    return <div>Log out!</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/account.js